import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { connectToContext, IAppContext } from 'contextStore';
import { EventTarget, Attributes } from './types';

interface IProps extends IAppContext {
  name: string;
  value: string;
  onChange: (e: EventTarget) => void;
  attributes: Attributes;
  className: string;
  required: boolean;
  disabled: boolean;
  hideElement?: boolean;
  classNameССInput?: string;
}

class FileSourceInput extends Component<IProps> {
  onDrop = (files: Array<File>) => {
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();

      reader.onload = (event) => {
        this.onChange(event.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  onChange = (value: string) => {
    const { name, onChange } = this.props;
    const e = { target: { name, value } };

    onChange(e);
  };

  onClear = () => {
    this.onChange('');
  };

  renderImage(value: string) {
    const { i18next } = this.props;

    return (
      <div className="cc-drop__image">
        <img src={value} alt="" />
        <button type="button" onClick={this.onClear} className="form__button basic--button">
          {i18next.t(keyMap.sharedActionsClear)}
        </button>
      </div>
    );
  }

  renderInput() {
    const { attributes, i18next, hideElement = false, classNameССInput } = this.props;
    const { fileSourceSetting } = { ...attributes };

    const { availableMimeTypes, maxSize } = { ...fileSourceSetting };

    const accept = availableMimeTypes ? availableMimeTypes.join(',') : 'image/png';

    return (
      <Dropzone accept={accept} onDrop={this.onDrop} maxSize={maxSize || 2000000}>
        {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => {
          const additionalClasses = cn('cc-drop__input', {
            'dropzone--active': isDragActive,
            'dropzone--accept': isDragAccept,
            'dropzone--reject': isDragReject,
          });

          return (
            <div {...getRootProps({ className: additionalClasses })}>
              <div className={cn('cc-input', classNameССInput)} />
              {!hideElement && <div className="form__button basic--button">{i18next.t(keyMap.formsBrowse)}</div>}
              <input {...getInputProps()} />
            </div>
          );
        }}
      </Dropzone>
    );
  }

  render() {
    const { value } = this.props;

    if (value) {
      return this.renderImage(value);
    }

    return <div className="cc-drop">{this.renderInput()}</div>;
  }
}

export default connectToContext(FileSourceInput);
